var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c(
      "div",
      {
        staticClass: "btn-close",
        on: {
          click: function($event) {
            return _vm.$emit("closeModal")
          }
        }
      },
      [
        _c("v-img", {
          attrs: { src: require("@/assets/icons/clear_icon.svg") }
        })
      ],
      1
    ),
    _vm.checkDeleteAtivo == 0
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "tipo-ativo" },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "flex-column mt-7",
                    attrs: { align: "start" }
                  },
                  [
                    _c(
                      "v-col",
                      { staticClass: "d-flex flex-column align-left py-0" },
                      [
                        _c("span", { staticClass: "text-filelds" }, [
                          _vm._v("Tipo de ativo ")
                        ])
                      ]
                    ),
                    _c(
                      "v-col",
                      [
                        _c("v-select", {
                          staticClass: "input",
                          attrs: {
                            "return-object": "",
                            items: _vm.items,
                            "item-text": "name",
                            "menu-props": { bottom: true, offsetY: true },
                            placeholder: "Selecione",
                            color: "secondary",
                            required: "",
                            outlined: "",
                            rounded: "",
                            dense: "",
                            attach: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.$emit("onChange", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "keep-alive",
              [
                _c(
                  "v-form",
                  { ref: "form" },
                  [
                    _c(_vm.venda, {
                      tag: "component",
                      attrs: {
                        tipoAtivo: _vm.currentPropertie,
                        respGetAtiTipUserId_prop: _vm.respGetAtiTipUserId
                      },
                      on: { save: _vm.save }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            !_vm.objetoEhVazio(_vm.currentPropertie)
              ? _c("div", { staticClass: "btn-venda" }, [
                  _c("span", { on: { click: _vm.checkDelete } }, [
                    _vm._v("Excluir Ativo ")
                  ])
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm.checkDeleteAtivo != 0
      ? _c("div", [
          _c("span", [
            _vm._v(
              "confirmar exclusão do ativo " +
                _vm._s(_vm.dadosDoAtivo.codigo) +
                " - " +
                _vm._s(_vm.dadosDoAtivo.descricao)
            )
          ]),
          !_vm.objetoEhVazio(_vm.currentPropertie)
            ? _c("div", { staticClass: "btn-venda" }, [
                _c(
                  "span",
                  { staticClass: "span-ok", on: { click: _vm.deleteAtivo } },
                  [_vm._v("Sim")]
                ),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$emit("closeModal")
                      }
                    }
                  },
                  [_vm._v("Não")]
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [
        _vm._v("Excluir "),
        _c("span", { staticStyle: { color: "#f25a5a" } }, [_vm._v("Ativo")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }